import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import auth from '../../firebase.init';
import { useAuthState } from 'react-firebase-hooks/auth';
import logo from'../../assest/carlogo.png'
const Navbar = () => {
  const location=useLocation()
  const iconShow=location.pathname.includes("dashboard")
  const seiconShow=location.pathname.includes("dashboard")
  
  const [user] = useAuthState(auth);
  const logout = () => {
    signOut(auth)
    localStorage.removeItem('accessToken')
  }

  const menuItems = <>
    <li className='text-[16px] leading-[26px] font-semibold'><Link to='/home'>Home</Link></li>
    <li className='text-[16px] leading-[26px] font-semibold'> <Link to='/blogs'>Blogs</Link></li>
 

    {
      user && <li className='text-[16px] leading-[26px] font-semibold'> <Link to='/dashboard'>Dashboard</Link></li>
    }

    <li> {user ? <div onClick={logout} className='text-[16px] leading-[26px] font-semibold '> Signout </div> : <Link className='text-[16px] leading-[26px] font-semibold ' to='/login'>Login</Link>}</li>
    <li> {user && <div class="avatar">
      <div class="w-8 rounded-xl">
        <img src={user.photoURL} alt='noIamge' />
      </div>
    </div>}
    </li>

  </>
  return (
    <>
      <div className="navbar bg-gradient-to-r sticky top-0 z-[99] from-secondary to-primary flex justify-between px-5">
        <div className=" nabvar-start ">
          <div className="dropdown z-50">
        { seiconShow ||
         
            <label tabIndex="0" className="btn btn-ghost lg:hidden">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
            </label>
            }
            <ul tabIndex="0" className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
              {
                menuItems
              }
            </ul>
          </div>
          <Link to="/home" className=" w-[300px] md:w-full flex items-center gap-x-[5px] normal-case text-[10px] md:text-[18px] lg:text-[20px] font-bold"> <div className=' w-[50px] border h-[50px] rounded-[10px] flex justify-center items-center  border-gradient-to-r from-secondary to-primary'>
          <img  className='w-[35px] h-[35px]' src={logo} alt="" srcset="" /> </div>  CAR-PARTS-MANUFACTURER </Link>
        </div>
        <div className="navbar-center hidden lg:flex ">
          <ul className="menu menu-horizontal  p-0">
            {
              menuItems
            }
          </ul>
        </div>
        <div className="navbar-end lg:hidden">
       


         {
          iconShow && <label htmlFor="my-drawer-2" className="btn btn-primary drawer-button "> <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg></label>
         }
        </div>
      </div>

    </>
  );
};

export default Navbar;